import React, { createContext, useContext, useState, ReactNode } from 'react';

interface MobileLineDetailsContextType {
  isMobileLineDetailsActive: boolean;
  setIsMobileLineDetailsActive: (active: boolean) => void;
}

const MobileLineDetailsContext = createContext<MobileLineDetailsContextType | undefined>(undefined);

interface MobileLineDetailsProviderProps {
  children: ReactNode;
}

export const MobileLineDetailsProvider: React.FC<MobileLineDetailsProviderProps> = ({ children }) => {
  const [isMobileLineDetailsActive, setIsMobileLineDetailsActive] = useState(false);

  return (
    <MobileLineDetailsContext.Provider value={{ isMobileLineDetailsActive, setIsMobileLineDetailsActive }}>
      {children}
    </MobileLineDetailsContext.Provider>
  );
};

export const useMobileLineDetails = (): MobileLineDetailsContextType => {
  const context = useContext(MobileLineDetailsContext);
  if (context === undefined) {
    throw new Error('useMobileLineDetails must be used within a MobileLineDetailsProvider');
  }
  return context;
};
